import { toCamel } from '../Util/SnakeCamelUtil';
import { BaseService } from './BaseService';
import { GuestUserDAO } from '../DAO/GuestUserDAO';

/**
 * GuestUserService
 *
 * ログイン認証関係のロジックサービス
 * DAOで取得したデータを操作等行い、View側に渡す。
 */
export class GuestUserService extends BaseService {

	/**
	 * registerNewUser
	 * ゲストユーザー登録
	 */
	public async registerGuestUser(email: string, confirm: string, identifier: string) {
		if (!identifier) {
			identifier = '999999999';
		}
		const dao = new GuestUserDAO(this as BaseService);
		return await dao.registerGuestUser(email, confirm, identifier);
	}

	/**
	 * getGuestUserInfo
	 * ゲストユーザー情報の取得
	 * @returns ゲストユーザー情報
	 */
	public async getGuestUserInfo(key: string) {

		const userDao = new GuestUserDAO(this as BaseService);
		const ret = await userDao.getGuestUserInfo(key);
		const dist = toCamel(ret);

		return dist;
	}

	/**
	 * ゲストコードの再送信要求
	 * 正しければゲスト情報が取得される。失敗すればnull
	 * @param id
	 */
	public async updateGuestCode(id: number) {

		const dao = new GuestUserDAO(this as BaseService);
		const ret = await dao.resendGuestCode(id);

		if (!ret) {
			return ret;
		}

		return toCamel(ret);

	}

	/**
	 * ゲストコードの成否チェック
	 * 正しければゲスト情報が取得される。失敗すればnull
	 * @param id
	 * @param code
	 */
	public async checkGuestCode(id: number, code: string) {

		const dao = new GuestUserDAO(this as BaseService);
		const ret = await dao.checkGuestCode(id, code);

		if (!ret) {
			return ret;
		}

		return toCamel(ret);

	}
}
